import React from "react";
import styled from "styled-components";

const SidebarContainer = styled.div`
  width: 280px;
  flex-shrink: 0;
  align-self: flex-start;

  background-color: #ffffff;
  border-radius: 24px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

  @media (max-width: 992px) {
    width: 100%;
  }
`;

const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border: 1.5px solid #ffffff;
  border-radius: 14px;
  color: #0f5c66;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: #006b64;
    color: #006b64;
  }

  ${(props) =>
    props.active &&
    `
    background-color: #eef8f6;
    border-color: #0f8a7e;
    color: #0f5c66;
    box-shadow: none;
  `}
`;

const Arrow = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 18px;
  color: #8a4b00;
  font-weight: 700;
  font-size: 23px;
  line-height: 18px;
  transform: translateY(-1px);
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  width: ${(props) => (props.show ? "16px" : "0")};
`;

const Sidebar = ({ activeSection, onSelectSection, menuItems = [] }) => {
  return (
    <SidebarContainer data-internal-sidebar="true">
      {menuItems.map((item) => {
        const isActive = activeSection === item.id;
        return (
          <MenuItem
            key={item.id}
            active={isActive}
            onClick={() => onSelectSection(item.id)}
          >
            <Arrow show={isActive}>&raquo;</Arrow>
            {item.label}
          </MenuItem>
        );
      })}
    </SidebarContainer>
  );
};

export default Sidebar;
